import React, { ReactElement, useEffect } from 'react';
import { InjectedWizardStepProps } from '../../../components/Steps/WizardStep';
import { useDataCollection } from '../../../../hooks';
import { Form } from 'formik';
import FormRadio from '../../../components/Form/FormRadio';
import { buildDateOptions } from '../../../../data/enumerations';
import { WizardStep } from '../../../../types';
import StepHeader from '../../../components/Layout/StepHeader';

const StepYearOfBuilding = ({ completeStep, setNextStepId }: InjectedWizardStepProps): ReactElement<'div'> | null => {
    const { handleChange, handleBlur, values } = useDataCollection();
    const startOptionIndexWithPENB = 5;

    useEffect(() => {
        const { buildDate } = values;
        if (!buildDate) return;

        let indexOfBuildDate = 0;
        buildDateOptions.forEach(({ value }, index) => {
            if (value === buildDate) {
                indexOfBuildDate = index;
            }
        });

        const nextStepId =
            indexOfBuildDate <= startOptionIndexWithPENB ? WizardStep.HouseFloorPlanShape : WizardStep.HavePENB;
        setNextStepId && setNextStepId(nextStepId);
        completeStep && completeStep(true);

        /* TODO fix this TS errors
        if (buildDateOptions.reduce((acc: number, {value}, index) => {
            if (value === buildDate) return acc = index
        }), 0)*/
    }, [values]);

    return (
        <Form>
            <input type="hidden" tabIndex={1} />
            <div className="otz-main otz-main--big">
                <StepHeader title="Kdy byl Váš dům postaven?" subtitle="Vyberte období, ze kterého je váš dům. Pokud nevíte přesně, nic se neděje, tipněte si 🙂" />
                <div className={'row otz-row--md'}>
                    {buildDateOptions.map(({ value, title }) => {
                        return (
                            <div key={value} className={'col col--md-4 col--lg-3 ta-c p-l-10 p-r-10'}>
                                <FormRadio
                                    name="buildDate"
                                    value={value}
                                    id={value}
                                    label={title}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    className={'wiz-form-radio--fullwidth'}
                                    checked={value === values.buildDate}
                                />
                            </div>
                        );
                    })}
                </div>
            </div>
        </Form>
    );
};

export default StepYearOfBuilding;
